import Vue from 'vue'
import App from './app'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/reset.css'
import './styles/index.scss'
import axios from 'axios'
import Vuex from 'vuex'
import Dialog from 'vant/lib/dialog'
import { Base64 } from 'js-base64';
import Cookies from 'js-cookie'
require('es6-promise').polyfill()
Vue.use(Vuex)


Vue.use(Dialog);
Vue.use(Element, {size: 'medium'})
Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development'){
    Vue.prototype.apiUrl = 'http://api.mall.lypinyue.cyy';
    Vue.prototype.domainUrl = 'http://localhost:8083'
    Vue.prototype.mobileDomain = 'http://m.mall.lypinyue.cyy'
    Vue.prototype.loginDomain = 'http://localhost:8081'
    Vue.prototype.pcDomainUrl = 'http://www.c2cmall.cyy';
    Vue.prototype.pcLoginUrl = 'http://www.c2cmall.cyy/?app=member&act=login&ret_url='+encodeURIComponent(location.href);
    axios.defaults.baseURL = 'http://api.mall.lypinyue.cyy'
}else {
    Vue.prototype.pcDomainUrl = 'http://mall.lypinyue.com';
    Vue.prototype.pcLoginUrl = 'http://mall.lypinyue.com/?app=member&act=login&ret_url='+encodeURIComponent(location.href);
    Vue.prototype.apiUrl = 'https://api.mall.lypinyue.com';
    Vue.prototype.domainUrl = 'http://admin.store.shangduoke.com'
    Vue.prototype.mobileDomain = 'http://m.mall.lypinyue.com'
    Vue.prototype.loginDomain = 'https://m.mall.lypinyue.com'
    axios.defaults.baseURL = 'https://api.mall.lypinyue.com'
}

Vue.prototype.$http = axios
Vue.prototype.$http.defaults.withCredentials = true;

//http request 拦截器
axios.interceptors.request.use(
    config => {
        if (Cookies.get('access_token')) {
            var access_token = Cookies.get('access_token')// 判断是否存在token，如果存在的话，则每个http header都加上token
            var password = ''
            //config.headers.Authorization = 'Basic ' + Base64.encode(access_token+':'+password);
            config.headers.Authorization = 'Bearer ' + access_token;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });
var _this = this
// http response 拦截器
axios.interceptors.response.use(
    response => {

        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 返回 401 清除token信息并跳转到登录页面
                    //this.$store.commit('setToken',{access_token:null});
                    //sessionStorage.removeItem('access_token')
                    //console.log(Vue.prototype.loginDomain)
                    var screenWidth = window.screen.width;
                    if (screenWidth > 800){
                        //location.href = Vue.prototype.pcLoginUrl;
                        this.$router.push('/login')
                    }else {
                        location.href = Vue.prototype.loginDomain+'/jz/#/login?redirectUrl='+encodeURIComponent(location.href)
                    }
            }
        }
        return Promise.reject(error)   // 返回接口返回的错误信息
    });

const store = new Vuex.Store({
    state: {
        access_token: '',
        userId:{},
        storeId:{},
        breadcrumb:[]
    },
    mutations: {
        setToken (state,payload) {
            state.access_token = payload.access_token;
        },
        setUser(state,data){
            state.userId = data.user_id;
            Cookies.set('user_id',data.user_id)
            Cookies.set('access_token',data.access_token);
        },
        setStore(state,data){
            state.storeId = data.id;
            //sessionStorage.setItem('store',JSON.stringify(data))
            Cookies.set('storeId',data.id)
        },
        setBreadcrumb(state,data){
            state.breadcrumb = data;
            Cookies.set('breadcrumb',JSON.stringify(data))
        }
    }
})

new Vue({ // eslint-disable-line
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js